'use client';

import {
  DashboardTravelItineraryPlan,
  type DashboardTravelItineraryPlanProps,
} from '@tuic/web-compositions/my-trips/DashboardTravelItineraryPlan';
import { useState } from 'react';

import { Link } from '../../elements';

import type { ComponentBlock } from '@modules/prism-client/types/types';
import type PrismAPI from '@public/prism-types/2025-07-01';

type DashboardTravelItineraryPlanGlobalProps = Pick<
  DashboardTravelItineraryPlanProps,
  'travellers'
>;

export type TransitPlanFlexPageBlockItem = Omit<
  DashboardTravelItineraryPlanProps,
  keyof DashboardTravelItineraryPlanGlobalProps
> & {
  card?: Omit<DashboardTravelItineraryPlanProps['card'], 'cta'>;
  // This is for preventing slotting issues
  cardCta?: {
    link?: PrismAPI.LinkElement;
    label: string;
  };
};

export type TransitPlanFlexPageBlockData =
  DashboardTravelItineraryPlanGlobalProps & {
    items: TransitPlanFlexPageBlockItem[];
  };

export const TransitPlanFlexPageBlock: ComponentBlock<
  TransitPlanFlexPageBlockData
> = ({ data, fallback }) => {
  const [currentTravellerId, setCurrentTravellerId] = useState<
    string | undefined
  >();

  if (fallback) {
    return <DashboardTravelItineraryPlan fallback />;
  }

  if (!data) {
    return null;
  }

  const { travellers, items } = data;

  const item =
    items.find(item => item.ownTravellerId === currentTravellerId) || items[0];

  if (!item) {
    return <DashboardTravelItineraryPlan travellers={travellers} />;
  }

  return (
    <DashboardTravelItineraryPlan
      {...item}
      travellers={travellers}
      ownTravellerId={item.ownTravellerId}
      onSwitchTraveller={traveller => {
        setCurrentTravellerId(traveller);
      }}
      timelineEntries={item.timelineEntries}
      card={
        item.card
          ? {
              ...item.card,
              ...(item.cardCta
                ? {
                    cta: item.cardCta.link ? (
                      <Link data={item.cardCta.link}>{item.cardCta.label}</Link>
                    ) : (
                      item.cardCta.label
                    ),
                  }
                : {
                    cta: undefined,
                  }),
            }
          : undefined
      }
    />
  );
};
